import { ReactElement } from 'react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import get from 'lodash/get';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import styles from './CheckboxGroup.module.scss';
import { IPermissionSelector } from '~/services/api/users/types';

type IFieldValue = string[];

interface IProps {
  control: Control<any>;
  errors: FieldErrors;
  size?: 'medium' | 'small';
  name: string;
  label?: string;
  required?: boolean;
  selectors: IPermissionSelector[];
}

const CheckboxGroup = ({
  control,
  errors,
  size = 'medium',
  name,
  label,
  required = false,
  selectors = [],
}: IProps): ReactElement => {
  const error = get(errors, `${name}.message`, '');

  const handleChange = (fieldValue: IFieldValue, checkboxEvent: any) => {
    let res;
    const val = checkboxEvent.target.value;

    const exist = fieldValue.some(item => item === val);

    if (exist) {
      res = fieldValue.filter(item => item !== val);
    } else {
      res = [...fieldValue, val];
    }

    return res;
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => {
        if (!Array.isArray(value)) return <div>Checkbox group value must be array</div>;

        return (
          <FormControl required={required} component="fieldset">
            {label && <div className={styles.label}>{label}</div>}
            <ul className={styles.list}>
              {selectors.map(({ id, name: selectorName, description }) => (
                <li key={id} className={styles.item}>
                  <div className={styles.checkboxContainer}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name={id}
                          checked={value.includes(id)}
                          value={id}
                          onChange={option => onChange(handleChange(value, option))}
                          color="primary"
                          size={size}
                        />
                      }
                      label={`${selectorName} - ${description}`}
                      classes={{ root: styles.controlLabelRoot, label: styles.controlLabel }}
                    />
                  </div>
                </li>
              ))}
            </ul>
            {error && <FormHelperText error>{error}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
};

export default CheckboxGroup;
